module.exports = __webpack_public_path__ + "static/48-0c8ce8cbe845c281e7f0c077b6e5f8b5.jpg";